export var BrandedNotificationWorkflowTypes;
(function (BrandedNotificationWorkflowTypes) {
    BrandedNotificationWorkflowTypes["PBE"] = "PBE";
    BrandedNotificationWorkflowTypes["GPC"] = "GPC";
    BrandedNotificationWorkflowTypes["APPLICATION"] = "APPLICATION";
    BrandedNotificationWorkflowTypes["PHOTO_CAPTURE"] = "PC";
    BrandedNotificationWorkflowTypes["GENERIC"] = "GENERIC";
})(BrandedNotificationWorkflowTypes || (BrandedNotificationWorkflowTypes = {}));
//# sourceMappingURL=BrandedNotificationWorkflowTypes.js.map